export var identity = function identity(x) {
  return x;
};


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/utils/identity.js
// module id = 20
// module chunks = 0